import {Injectable} from '@angular/core';
import {ToolsService} from '../../../services/tools.service';
import {EnumsService} from '../../../services/enums.service';
import {UrlValidatorService} from '../../../services/url-validator.service';
import {ActivatedRouteSnapshot, Params, Router} from '@angular/router';
import {RoutesEnums, RoutesQueryParamsEnum} from '../../../enums/RoutesEnums';
import {AllowedParamGroup} from '../../../types/AllowedParamGroup';
import {UrlBuilderService} from '../../../services/url-builder.service';
import {QueryParams} from '../../../types/QueryParams';
import {WPPostBlog} from '../../../types/WPPostBlog';
import {RedirectService} from '../../../services/redirect.service';

@Injectable()
export class BlogPostUrlResolverService {
  public postId: number = 0;
  public postSlug: string = '';
  public isPreview: boolean = false;

  constructor(
    private tools: ToolsService,
    private enumsService: EnumsService,
    private urlValidator: UrlValidatorService,
    private urlBuilder: UrlBuilderService,
    private router: Router,
    private redirect: RedirectService,
  ) {}

  public resetState(): void {
    this.postId = 0;
    this.postSlug = '';
    this.isPreview = false;
  }

  public cleanUpUrl(snapshot: ActivatedRouteSnapshot): boolean {
    const allowedQueryParams: string[] = [
      RoutesQueryParamsEnum.PREVIEW,
      RoutesQueryParamsEnum.GCLID,
      RoutesQueryParamsEnum.UTM_CAMPAIGN,
      RoutesQueryParamsEnum.UTM_SOURCE,
      RoutesQueryParamsEnum.UTM_MEDIUM,
      RoutesQueryParamsEnum.UTM_SIZE,
      RoutesQueryParamsEnum.UTM_TERM,
      RoutesQueryParamsEnum.UTM_CONTENT,
      RoutesQueryParamsEnum.FBCLID,
      RoutesQueryParamsEnum.FBQBTID,
    ];
    const allowedParamsGroups: AllowedParamGroup[] = [];

    allowedParamsGroups.push({
      params: [
        {
          type: 'id-slug',
          value: null,
        },
      ],
    });

    const routingBase: string[] = this.urlBuilder.CreateBlogRouterLink();
    return this.urlValidator.cleanUpUrlAndRedirect(snapshot, routingBase, allowedParamsGroups, allowedQueryParams);
  }

  public processRouteAndQueryParams(params: Params, queryParams: QueryParams): void {
    this.updateIsPreview(queryParams);

    if (!this.tools.isNil(params.id)) {
      this.postId = params.id;
    }

    if (!this.tools.isNil(params.urlPath)) {
      this.postSlug = params.urlPath;
    }
  }

  public processFailToGetPostData(error: any, info?: any) {
    console.error(`Failed to get data from API: ${error}, additional info: ${info}`);
    this.redirect.redirect(['/', RoutesEnums.BLOG]);
  }

  public conditionalRedirectToValidSlug(post: WPPostBlog): boolean {
    if (!this.tools.areStringsEqualIgnoringEncoding(this.postSlug, decodeURI(post.slug))) {
      const newUrl: string[] = this.urlBuilder.CreateBlogPostRouterLink(post.id, decodeURI(post.slug));
      this.redirect.redirect(newUrl);
      return true;
    }
    return false;
  }

  private updateIsPreview(params: Params): void {
    this.isPreview =
      !this.tools.isNil(params) &&
      !this.tools.isNil(params[RoutesQueryParamsEnum.PREVIEW]) &&
      params[RoutesQueryParamsEnum.PREVIEW] === '1';
  }
}
